import React from 'react';
import ProtectedRoute from '../../router/ProtectedRoute';

const LearnHomePage = React.lazy(() => import('../../features/learn/LearnHomePage'));
const FlowPage = React.lazy(() => import('../../features/learn/FlowPage'));
const TrainingProgressPage = React.lazy(() => import('../../features/learn/TrainingProgressPage'));

const page = (node, section) => (
  <ProtectedRoute {...(section ? { section, action: 'view' } : {})}>
    <React.Suspense fallback={null}>{node}</React.Suspense>
  </ProtectedRoute>
);

/**
 * Learn the flow (18 Oct 2026): every signed-in user; each page shows only the
 * flows their permissions open. Training progress is for trainers.
 */
export const learnRoutes = [
  { path: '/learn', element: page(<LearnHomePage />) },
  { path: '/learn/:flowId', element: page(<FlowPage />) },
  { path: '/control/training', element: page(<TrainingProgressPage />, 'training_progress') },
];

export default learnRoutes;
